import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_NETWORKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_LINKS_LIST,
  FETCH_SOCIAL_LINKS_LIST_ERROR,
  CLEAR_FETCH_SOCIAL_LINKS_LIST,
  CREATE_SOCIAL_LINK_SUCCESS,
  CREATE_SOCIAL_LINK_ERROR,
  CLEAR_CREATE_SOCIAL_LINK,
  PATCH_SOCIAL_LINK_SUCCESS,
  PATCH_SOCIAL_LINK_ERROR,
  CLEAR_PATCH_SOCIAL_LINK,
  DELETE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK_ERROR,
  CLEAR_DELETE_SOCIAL_LINK,
  APPLY_SOCIAL_LINK_DRAG,
  APPLY_SOCIAL_LINK_DRAG_ERROR,
  CLEAR_SOCIAL_LINK_DRAG,
} from 'redux/social/types';


export const fetchSocialNetworksList = () => baseErrorsHandlerDecorator(
  FETCH_SOCIAL_NETWORKS_LIST,
  FETCH_SOCIAL_NETWORKS_LIST_ERROR,
  () => restapi.get(addLang('links/social_links/social_networks/')),
  false,
);

export const clearFetchSocialNetworksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_SOCIAL_NETWORKS_LIST,
  });
};

export const fetchSocialLinksList = () => baseErrorsHandlerDecorator(
  FETCH_SOCIAL_LINKS_LIST,
  FETCH_SOCIAL_LINKS_LIST_ERROR,
  () => restapi.get(addLang('links/social_links/')),
  false,
);

export const clearFetchSocialLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_SOCIAL_LINKS_LIST,
  });
};

export const createSocialLink = formData => baseErrorsHandlerDecorator(
  CREATE_SOCIAL_LINK_SUCCESS,
  CREATE_SOCIAL_LINK_ERROR,
  () => restapi.post(addLang('links/social_links/'), formData),
  false,
  true /* actionSucces */,
);

export const clearCreateSocialLink = () => dispatch => {
  dispatch({
    type: CLEAR_CREATE_SOCIAL_LINK,
  });
};

export const patchSocialLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_SOCIAL_LINK_SUCCESS,
  PATCH_SOCIAL_LINK_ERROR,
  () => restapi.patch(addLang(`links/social_links/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchSocialLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_SOCIAL_LINK,
  });
};

export const deleteSocialLink = linkId => baseErrorsHandlerDecorator(
  DELETE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK_ERROR,
  () => restapi.delete(addLang(`links/social_links/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteSocialLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_SOCIAL_LINK,
  });
};

export const applySocialLinkDrag = formData => baseErrorsHandlerDecorator(
  APPLY_SOCIAL_LINK_DRAG,
  APPLY_SOCIAL_LINK_DRAG_ERROR,
  () => restapi.post(addLang('links/social_links/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearSocialLinkDrag = () => dispatch => {
  dispatch({
    type: CLEAR_SOCIAL_LINK_DRAG,
  });
};
